<template>
    <div class="po-tab">
        <div class="po-hd">
            <a-radio-group v-model="activeView" class="po-seg">
                <a-radio-button value="flat">Analítico</a-radio-button>
                <a-radio-button value="loja">Por loja</a-radio-button>
                <a-radio-button value="matriz">Por fornecedor</a-radio-button>
                <a-radio-button value="produto">Por produto</a-radio-button>
            </a-radio-group>
            <a-checkbox v-model="pendencyOnly" class="po-pendency">Apenas abaixo do faturamento mínimo</a-checkbox>
        </div>

        <cc-loader-full v-if="is_loading_sellers && !pre_orders.length" />

        <!-- <ByFornecedorTable
            v-else-if="activeView == 'fornec'"
            :pre_orders="pre_orders"
            :is_loading="is_loading_sellers"
            :pendencyOnly="pendencyOnly"
            @reload="onReload"
            @giro="openGiro"
        /> -->
        <!-- <ByLojaTable
            v-else-if="activeView == 'loja-antiga'"
            :pre_orders="pre_orders"
            :is_loading="is_loading_sellers"
            :pendencyOnly="pendencyOnly"
            :selected-offer-keys.sync="selectedOfferKeys"
            @reload="onReload"
            @giro="openGiro"
        /> -->
        <ByLojaTableV2
            v-else-if="activeView == 'loja'"
            :products="flatProducts"
            :products_loading="flatProductsLoading"
            :ordered-offers="orderedOffers"
            :generating="isGenerating"
            :refreshing-erp="refreshingErp"
            :pendencyOnly="pendencyOnly"
            :selected-offer-keys.sync="selectedOfferKeys"
            :saved-cells="savedCells"
            @reload="onReload"
            @generate-orders="handleGenerateOrders"
            @refresh-erp="handleRefreshErp"
            @giro="openGiro"
            @cell-focus="onCellFocus"
            @quantity-edited="handleQuantityEdited"
            @save-quantity="saveQuantity"
            @quantity-synced="handleQuantitySynced"
        />
        <MatrixTable
            v-else-if="activeView == 'matriz'"
            :compact="compact"
            :products="flatProducts"
            :products_loading="flatProductsLoading"
            :ordered-offers="orderedOffers"
            :ordered-cells="orderedCells"
            :pending-quantities="pendingQuantities"
            :generating="isGenerating"
            :refreshing-erp="refreshingErp"
            :pendencyOnly="pendencyOnly"
            :selected-offer-keys.sync="selectedOfferKeys"
            :saved-cells="savedCells"
            @reload="onReload"
            @generate-orders="handleGenerateOrders"
            @refresh-erp="handleRefreshErp"
            @giro="openGiro"
            @cell-focus="onCellFocus"
            @quantity-edited="handleQuantityEdited"
            @save-quantity="saveQuantity"
            @quantity-synced="handleQuantitySynced"
        />
        <ByProdutoTable
            v-else-if="activeView == 'produto'"
            :products="flatProducts"
            :products_loading="flatProductsLoading"
            :ordered-offers="orderedOffers"
            :generating="isGenerating"
            :refreshing-erp="refreshingErp"
            :pendencyOnly="pendencyOnly"
            :selected-offer-keys.sync="selectedOfferKeys"
            :saved-cells="savedCells"
            @reload="onReload"
            @generate-orders="handleGenerateOrders"
            @refresh-erp="handleRefreshErp"
            @giro="openGiro"
            @cell-focus="onCellFocus"
            @quantity-edited="handleQuantityEdited"
            @save-quantity="saveQuantity"
            @quantity-synced="handleQuantitySynced"
        />
        <FlatTable
            v-else-if="activeView == 'flat'"
            :products="flatProducts"
            :products_loading="flatProductsLoading"
            :ordered-offers="orderedOffers"
            :generating="isGenerating"
            :refreshing-erp="refreshingErp"
            :pendencyOnly="pendencyOnly"
            :selected-offer-keys.sync="selectedOfferKeys"
            :saved-cells="savedCells"
            @reload="onReload"
            @generate-orders="handleGenerateOrders"
            @refresh-erp="handleRefreshErp"
            @giro="openGiro"
            @cell-focus="onCellFocus"
            @quantity-edited="handleQuantityEdited"
            @save-quantity="saveQuantity"
            @quantity-synced="handleQuantitySynced"
        />
        <ComingSoonTab
            v-else
            title="Matriz produto × loja"
            icon="grid_view"
        />
    </div>
</template>

<script>
import ByFornecedorTable from "./_by-fornecedor.table.vue";
import ByLojaTable from "./_by-loja.table.vue";
import ByLojaTableV2 from "./_by-loja-v2.table.vue";
import MatrixTable from "./_matrix.table.vue";
import ByProdutoTable from "./_by-produto.table.vue";
import FlatTable from "./_flat.table.vue";
import ComingSoonTab from "../placeholders/_coming-soon.tab.vue";
import RequestService from "@/services/v3/request.service";
import QuotationService from "@/services/QuotationService";
import ErrorHandlerService from "@/services/ErrorHandlerService";
import { loaderMixin } from "@/mixins/sweet-loader.mixin";
import { partial_order_mixin } from "@/mixins/partial-order.mixin";

// Only the views actually reachable from the po-seg buttons — 'fornec' and
// 'loja-antiga' are commented out in the template and must never be
// persisted/restored from the URL.
const VIEW_KEYS = ["flat", "loja", "matriz", "produto"];

export default {
    name: "PreOrdersTab",
    mixins: [loaderMixin, partial_order_mixin],
    components: {
        ByProdutoTable,
        ByFornecedorTable,
        ByLojaTable,
        ByLojaTableV2,
        ComingSoonTab,
        MatrixTable,
        FlatTable,
    },
    props: {
        pre_orders: { type: Array, default: () => [] },
        is_loading_sellers: { type: Boolean, default: false },
        compact: { type: Boolean, default: false },
    },
    data() {
        return {
            activeView: VIEW_KEYS.includes(this.$route.query.view) ? this.$route.query.view : "matriz",
            pendencyOnly: false,
            // Shared across Matriz / Por Loja (nova API) / Por Produto /
            // Analítico — same row-key shape
            // (`${produto}-${loja}-${fornecedor}-${vendedor}`) in all four,
            // so a selection made in one survives switching views.
            selectedOfferKeys: [],
            // Same reasoning as selectedOfferKeys: owned here so a cell
            // marked "saved" in one view is still marked when switching to
            // another, and survives onReload() re-fetching flatProducts.
            savedCells: {},
            // Quantities typed in any view that a pre_orders_report() response
            // may not reflect yet (typing, save debouncing or in flight).
            // Re-applied on top of every response so a reload can't revert
            // them; an entry is dropped once a fetch that started after its
            // save returned (`confirmedAt`, a syncSeq value) comes back.
            pendingQuantities: {},
            saveTimers: {},
            syncSeq: 0,
            latestFetchSeq: 0,
            quotationSvc: new QuotationService(),
            // Fetched once here and handed to Matriz/Por Produto/Analítico/Por
            // loja (nova API) as a prop — those 4 views all consume the exact
            // same pre_orders_report() call, so there is no reason for each to
            // fetch it again on every tab switch.
            v3Svc: new RequestService(),
            flatProducts: [],
            flatProductsLoading: false,
            orderedCells: {},
            // `${produto}-${vendedor}` with an order in any loja — the price
            // is one per vendedor for all lojas, so "Negociar preço" locks on
            // this, not on orderedCells.
            orderedOffers: {},
            // Blocks every "Gerar pedido"/"Enviar pedido" action across all 4
            // views while a generate-orders call is in flight: two overlapping
            // calls for the same cotação used to let the first one's reload
            // fire while the second was still writing, hiding items that were
            // in fact still pending until a manual refresh.
            isGenerating: false,
            refreshingErp: false,
        };
    },
    computed: {
        flatProductsByKey() {
            return new Map(this.flatProducts.map((row) => [this.cellKey(row), row]));
        },
    },
    methods: {
        onReload(options) {
            this.$emit("load-pre-orders");
            this.loadFlatProducts(options);
        },
        cellKey(row) {
            return `${row.id}-${row.store_id}-${row.provider_id}-${row.seller_id}`;
        },
        openGiro(record, siblings) {
            this.$emit('giro', record, siblings)
        },
        onCellFocus(record, storeId, siblings) {
            this.$emit('cell-focus', record, storeId, siblings)
        },
        setFlatQuantity(key, requested_quantity) {
            const item = this.flatProductsByKey.get(key);

            if (item) {
                item.requested_quantity = requested_quantity;
            }
        },
        handleQuantityEdited({ key, requested_quantity }) {
            this.pendingQuantities[key] = { value: requested_quantity, requested: false, confirmedAt: null };
            this.$delete(this.savedCells, key);
            this.setFlatQuantity(key, requested_quantity);
        },
        saveQuantity({ key, product_id, store_id, seller_id }) {
            const pending = this.pendingQuantities[key];

            if (!pending || pending.requested) return;

            pending.requested = true;
            clearTimeout(this.saveTimers[key]);

            this.saveTimers[key] = setTimeout(() => {
                delete this.saveTimers[key];

                // Matriz pads lojas that have no pre_orders_report() row yet —
                // re-fetch after saving one so its estoque/sugerido show up.
                const isNewRow = !this.flatProductsByKey.has(key);

                this.quotationSvc
                    .sendQuantidade({
                        numerocotacao: this.$route.params.id,
                        quantidade: Number(pending.value || 0),
                        vendedor: seller_id,
                        produto: product_id,
                        loja: store_id,
                    })
                    .then(() => {
                        this.snack("Quantidade salva.");

                        if (this.pendingQuantities[key] !== pending) return;

                        pending.confirmedAt = ++this.syncSeq;
                        this.$set(this.savedCells, key, true);

                        if (isNewRow) {
                            this.onReload({ silent: true });
                        }
                    })
                    .catch((error) => {
                        if (this.pendingQuantities[key] === pending) {
                            delete this.pendingQuantities[key];
                        }

                        this.snack("Não foi possível salvar a quantidade.", "error");
                        ErrorHandlerService.handle(error, this.$store);
                    });
            }, 500);
        },
        handleQuantitySynced({ key, requested_quantity }) {
            this.pendingQuantities[key] = { value: requested_quantity, requested: true, confirmedAt: ++this.syncSeq };
            this.setFlatQuantity(key, requested_quantity);
        },
        applyPendingQuantities(rows, fetchSeq) {
            const rowsByKey = new Map(rows.map((row) => [this.cellKey(row), row]));

            Object.keys(this.pendingQuantities).forEach((key) => {
                const pending = this.pendingQuantities[key];

                if (pending.confirmedAt !== null && pending.confirmedAt < fetchSeq) {
                    delete this.pendingQuantities[key];
                    return;
                }

                const row = rowsByKey.get(key);

                if (row) {
                    row.requested_quantity = pending.value;
                }
            });
        },
        handleGenerateOrders(keys) {
            const payload = keys.map((key) => {
                const [productId, storeId, providerId, sellerId] = key.split("-");
                return {
                    product_id: Number(productId),
                    store_id: Number(storeId),
                    provider_id: Number(providerId),
                    seller_id: Number(sellerId),
                };
            });

            if (this.partialOrdersEnabled()) return this.generatePartialOrders(payload);

            this.isGenerating = true;

            this.v3Svc
                .generate_orders(this.$route.params.id, payload)
                .then((response) => {
                    const total = Array.isArray(response.data) ? response.data.length : 0;
                    const message = total
                        ? `${total} pedido(s) gerado(s) com sucesso.`
                        : "Pedidos gerados com sucesso.";

                    this.$swal.fire("Sucesso!", message, "success");
                    this.selectedOfferKeys = [];
                    this.onReload();
                })
                .catch((error) => {
                    this.$swal.fire("Erro!", "Não foi possível gerar um ou mais pedidos.", "error");
                    ErrorHandlerService.handle(error, this.$store);
                })
                .finally(() => {
                    this.isGenerating = false;
                });
        },
        /**
         * Pedido parcial (CLUB-1443): as mesmas chaves, pelo endpoint que só
         * pede o que ainda não virou pedido. A view já confirmou o pedido;
         * aqui a pergunta é só se a digitação continua.
         */
        generatePartialOrders(keys) {
            return this.partial_order_round(
                this.$route.params.id,
                { keys },
                {
                    title: "Realizar o pedido?",
                    text: `${keys.length} item(ns) selecionado(s) serão pedidos em pedidos novos.`,
                },
                {
                    start: () => (this.isGenerating = true),
                    finish: () => (this.isGenerating = false),
                    // As views marcam a linha como "enviando" antes de emitir;
                    // um recarregamento visível limpa essa marca.
                    cancel: () => this.onReload(),
                }
            ).then((data) => {
                if (!data) {
                    this.onReload();
                    return;
                }
                this.selectedOfferKeys = [];
                this.onReload();
                this.$emit("partial-order-done", data);
            });
        },
        handleRefreshErp(keys) {
            const items = [];
            const seen = new Set();

            keys.forEach((key) => {
                const [productId, storeId] = key.split("-");
                const pair = `${productId}-${storeId}`;
                if (seen.has(pair)) return;
                seen.add(pair);
                items.push({ product_id: Number(productId), store_id: Number(storeId) });
            });

            if (!items.length) return;

            this.refreshingErp = true;

            this.v3Svc
                .refresh_erp_data(this.$route.params.id, items)
                .then((response) => {
                    const updated = response.data && response.data.products ? response.data.products.length : 0;
                    this.snack(
                        updated
                            ? `Estoque e custo atualizados para ${updated} produto(s).`
                            : "Nenhum dos produtos selecionados foi encontrado no ERP."
                    );
                    this.selectedOfferKeys = [];
                    this.onReload();
                })
                .catch((error) => {
                    this.snack("Não foi possível atualizar estoque e custo.", "error");
                    ErrorHandlerService.handle(error, this.$store);
                })
                .finally(() => {
                    this.refreshingErp = false;
                });
        },
        loadFlatProducts({ silent = false } = {}) {
            const fetchSeq = ++this.syncSeq;

            this.latestFetchSeq = fetchSeq;

            if (!silent) {
                this.flatProductsLoading = true;
            }

            this.v3Svc
                .pre_orders_report(this.$route.params.id, true)
                .then((response) => {
                    // A newer fetch already went out — only its snapshot is applied.
                    if (fetchSeq !== this.latestFetchSeq) return;

                    const rows = (response.data || []).map((row) =>
                        Number(row.erp_last_purchase_price) > 0
                            ? { ...row, last_purchase: Number(row.erp_last_purchase_price) }
                            : row
                    );
                    const orderedCells = {};
                    const orderedOffers = {};

                    rows.filter((row) => row.is_purchased).forEach((row) => {
                        orderedCells[`${row.id}-${row.store_id}-${row.provider_id}-${row.seller_id}`] = Number(row.requested_quantity) || 0;
                        orderedOffers[`${row.id}-${row.seller_id}`] = true;
                    });

                    const flatProducts = rows.filter((row) => !row.is_purchased);

                    this.applyPendingQuantities(flatProducts, fetchSeq);

                    this.flatProducts = flatProducts;
                    this.orderedCells = orderedCells;
                    this.orderedOffers = orderedOffers;
                })
                .catch((error) => {
                    ErrorHandlerService.handle(error, this.$store);
                })
                .finally(() => {
                    if (fetchSeq === this.latestFetchSeq) {
                        this.flatProductsLoading = false;
                    }
                });
        },
    },
    mounted() {
        this.loadFlatProducts();
    },
    watch: {
        activeView(newView) {
            if (this.$route.query.view !== newView) {
                this.$router
                    .replace({ query: { ...this.$route.query, view: newView } })
                    .catch(() => {});
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.po-tab {
    padding: 20px;
}
.po-hd {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 12px;
    margin-bottom: 16px;
}
.po-seg {
    display: inline-flex;
    border: 1px solid #d9d9d9;
    border-radius: 8px;
    overflow: hidden;

    .ant-radio-button-wrapper {
        height: 34px;
        line-height: 34px;
        padding: 0 14px;
        border: none;
        border-radius: 0;
        background: #fff;
        font-size: 13px;
        font-weight: 500;
        color: #595959;
        box-shadow: none;

        &::before {
            display: none;
        }
        & + .ant-radio-button-wrapper {
            border-left: 1px solid #d9d9d9;
        }
        &:hover {
            color: #595959;
        }
        &:focus-within {
            outline: none;
            box-shadow: none;
        }
    }
    .ant-radio-button-wrapper-checked,
    .ant-radio-button-wrapper-checked:hover {
        background: var(--primary-color-opacity, rgba(232, 96, 44, 0.08));
        color: var(--primary-color);
        font-weight: 600;
        box-shadow: none;
    }
}
.po-pendency {
    font-size: 13px;
    color: #595959;
}
</style>
